import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SafeHtmlDirective } from '../../directives/safe-html.directive';

@Component({
  selector: 'app-mode-demploi-voir',
  standalone: true,
  imports: [CommonModule, SafeHtmlDirective],
  template: `
    <section class="mode-emploi-viewer">
      <header class="viewer-header">
        <h1>{{ nomFormatted }}</h1>
      </header>
      <div class="viewer-content" *ngIf="contenu; else loading" [appSafeHtml]="contenu"></div>
      <ng-template #loading>
        <div class="loading">Chargement...</div>
      </ng-template>
    </section>
  `,
  styles: [`
    .mode-emploi-viewer {
      padding: 2rem;
      max-width: 900px;
      margin: 0 auto;
    }

    .viewer-header {
      margin-bottom: 2rem;
      border-bottom: 2px solid #73d8ff;
      padding-bottom: 1rem;
    }

    .viewer-header h1 {
      margin: 0;
      color: #73d8ff;
      font-size: 2rem;
      text-transform: capitalize;
    }

    .viewer-content {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(115, 216, 255, 0.3);
      border-radius: 8px;
      padding: 1.5rem;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.9);
    }

    .viewer-content h2 {
      color: #73d8ff;
      margin-top: 1.5rem;
      margin-bottom: 0.5rem;
    }

    .viewer-content h3 {
      color: #a0e7ff;
      margin-top: 1rem;
      margin-bottom: 0.5rem;
    }

    .viewer-content p {
      margin: 0.5rem 0;
    }

    .viewer-content ul,
    .viewer-content ol {
      margin: 0.5rem 0;
      padding-left: 2rem;
    }

    .viewer-content table {
      width: 100% !important;
      border-collapse: collapse;
      margin: 1rem 0;
    }

    .viewer-content table td,
    .viewer-content table th {
      padding: 0.5rem;
    }

    :host ::ng-deep .viewer-content table {
      width: 100% !important;
      max-width: 100% !important;
      border-collapse: collapse;
    }

    :host ::ng-deep .viewer-content table td,
    :host ::ng-deep .viewer-content table th {
      padding: 0.5rem;
    }

    .viewer-content img {
      max-width: 100%;
      border-radius: 4px;
      margin: 1rem 0;
    }

    .loading {
      text-align: center;
      padding: 2rem;
      color: #73d8ff;
    }
  `]
})
export class ModeDemploiVoirPage implements OnInit {
  contenu: string | null = null;
  nomFormatted: string = '';
  private nom: string = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.nom = params['nom'] || '';
      this.nomFormatted = this.nom
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      this.loadModeEmploi();
    });
  }

  private loadModeEmploi(): void {
    if (!this.nom) return;
    
    this.http
      .get<{ contenu: string }>(`${environment.apiBaseUrl}/api/mode-emploi/${this.nom}`)
      .subscribe({
        next: (response) => {
          this.contenu = response.contenu || '<p>Aucun contenu disponible.</p>';
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Erreur lors du chargement du mode d\'emploi:', err);
          this.contenu = '<p>Erreur : Mode d\'emploi introuvable.</p>';
          this.cdr.detectChanges();
        },
      });
  }
}
